import { sessionTypes } from "../actions/session";

const initialState = {
  showBanner: null
};

export default function session(state = initialState, { type, payload }) {
  console.log('getting type', type);
  switch (type) {
    case sessionTypes.SHOW_BANNER:
      return { ...state, showBanner: payload.showBanner };

    default:
      return state;
  }
}
